export default __webpack_public_path__ + "static/media/home.c3e432f4.png";